function on( selector, eventType, childSelector, eventHandler ) {
	const elements = document.querySelectorAll( selector );
	for ( const element of elements ) {
		element.addEventListener( eventType, ( eventOnElement ) => {
			if ( eventOnElement.target.matches( childSelector ) ) {
				eventHandler( eventOnElement );
			}
		} );
	}
}

function getData( url ) {
	return fetch( url, {
		method: 'GET',
		credentials: 'same-origin',
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
		},
		redirect: 'follow',
	} );
}

function postData( url, formData ) {
	return fetch( url, {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
		},
		redirect: 'follow',
		body: formData || new FormData(),
	} );
}

function getCookie( name ) {
	const cookie = {};
	document.cookie.split( ';' ).forEach( function( el ) {
		const [ k, v ] = el.split( '=' );
		cookie[ k.trim() ] = v;
	} );
	return cookie[ name ];
}

function setCookie( name, value, days ) {
	let expires = '';
	if ( days ) {
		const date = new Date();
		date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
		expires = '; expires=' + date.toUTCString();
	}
	document.cookie = name + '=' + ( value || '' ) + expires + ';path=/;SameSite=Lax';
}

export { on, getData, postData, getCookie, setCookie };
